var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibararyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "libarary_icon",
    transform: "translate(20278 14452)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176063",
    "data-name": "Rectangle 176063",
    width: 28,
    height: 28,
    transform: "translate(-20278 -14452)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "resources",
    transform: "translate(-20287.18 -14461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526077",
    "data-name": "Path 1526077",
    d: "M71.289,75.774a1.466,1.466,0,1,0,1.478,1.466A1.474,1.474,0,0,0,71.289,75.774Zm0,2.273a.807.807,0,1,1,.819-.807A.814.814,0,0,1,71.289,78.047Z",
    transform: "translate(-40.105 -44.104)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526078",
    "data-name": "Path 1526078",
    d: "M71.417,41.313h1.456a.329.329,0,0,0,0-.659H71.417a.329.329,0,0,0,0,.659Z",
    transform: "translate(-40.961 -20.554)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526079",
    "data-name": "Path 1526079",
    d: "M34.585,18.461H30.474V10.329A.329.329,0,0,0,30.144,10H13.107a.329.329,0,0,0-.329.329v1.088h-.834a1.944,1.944,0,1,0,0,3.888h.834v2.182h-.834a1.944,1.944,0,1,0,0,3.888h.834v2.182h-.834a1.944,1.944,0,1,0,0,3.888h.834v2.182h-.834a1.944,1.944,0,1,0,0,3.888h.834V34a.329.329,0,0,0,.329.329h12.9v.258a1.775,1.775,0,0,0,1.773,1.773h6.8a1.775,1.775,0,0,0,1.773-1.773V20.234a1.775,1.775,0,0,0-1.773-1.773ZM11.944,14.646a1.285,1.285,0,1,1,0-2.57h.834v2.57Zm0,6.07a1.285,1.285,0,1,1,0-2.57h.834v2.57Zm0,6.07a1.285,1.285,0,1,1,0-2.57h.834v2.57Zm0,6.07a1.285,1.285,0,1,1,0-2.57h.834v2.57Zm1.493.81v-3.38H14.93a.329.329,0,0,0,0-.659H13.437V24.217H14.93a.329.329,0,0,0,0-.659H13.437V18.146H14.93a.329.329,0,0,0,0-.659H13.437V12.076H14.93a.329.329,0,0,0,0-.659H13.437v-.758H29.815v7.8H27.783a1.775,1.775,0,0,0-1.773,1.773V33.667H13.437Zm22.262.917A1.115,1.115,0,0,1,34.585,35.7h-6.8a1.115,1.115,0,0,1-1.114-1.114V20.234a1.115,1.115,0,0,1,1.114-1.114h6.8A1.115,1.115,0,0,1,35.7,20.234Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526080",
    "data-name": "Path 1526080",
    d: "M71.047,50.006H66.062a.329.329,0,0,0,0,.659h4.985a.329.329,0,1,0,0-.659Z",
    transform: "translate(-37.37 -26.825)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526081",
    "data-name": "Path 1526081",
    d: "M71.047,58.214H66.062a.329.329,0,0,0,0,.659h4.985a.329.329,0,1,0,0-.659Z",
    transform: "translate(-37.37 -32.329)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526082",
    "data-name": "Path 1526082",
    d: "M71.047,66.422H66.062a.329.329,0,0,0,0,.659h4.985a.329.329,0,1,0,0-.659Z",
    transform: "translate(-37.37 -37.833)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibararyIcon);
export default __webpack_public_path__ + "static/media/libarary_icon.516e54b78e6ab4992d62233de15f9969.svg";
export { ForwardRef as ReactComponent };